import type { DarklyProductFlag } from '../shared/constants';
import { type FlipperFlagValues, type ProductFlagValues, ProductFlipperFlagService } from './ProductFlipperFlag.service';
import type { LegacyProductFlag } from './constants/productFlipperFlagRelation';

export class ProductFlagService {
  isProductFlagEnabled(
    productFlagName: LegacyProductFlag | DarklyProductFlag,
    productFlags: ProductFlagValues,
    flipperFlags: FlipperFlagValues
  ): boolean {
    const productFlipperFlagService = new ProductFlipperFlagService();
    const mergedFlags = productFlipperFlagService.mergeFlags(
      productFlags,
      productFlipperFlagService.getFlipperOverridesForProductFlags(flipperFlags)
    );
    return Boolean(mergedFlags[productFlagName]);
  }
}
